// extracted by mini-css-extract-plugin
export default {"btn":"CreatePost_btn__2VaEq","modalContent":"CreatePost_modalContent__ZsuMK","title":"CreatePost_title__WZFi0","error":"CreatePost_error__ITPI6"};